import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Header } from '../components/header/Header';
import { HeaderCheckout } from '../components/header/HeaderCheckout';
const HeaderContainer = (_a) => {
    var { menuType } = _a, props = __rest(_a, ["menuType"]);
    return menuType === 'checkout' ? _jsx(HeaderCheckout, Object.assign({}, props)) : _jsx(Header, Object.assign({}, props));
};
export default HeaderContainer;
